import { render } from "./RolesEditorView.vue?vue&type=template&id=0df42cae&scoped=true"
import script from "./RolesEditorView.vue?vue&type=script&lang=js"
export * from "./RolesEditorView.vue?vue&type=script&lang=js"

import "./RolesEditorView.vue?vue&type=style&index=0&id=0df42cae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0df42cae"]])

export default __exports__